// Copyright (c) 2016 Deere & Company

import DealerRecommendationList, {getDefaultState} from '../state/dealer-recommendation-list';
import actions from '../../actions-list';

const updateDealerRecommendations = (state, action) => {

    /* eslint-enable array-callback-return, consistent-return */

    if (action.paginationType === 'requestedRecommendation') {

        return (
            DealerRecommendationList.update(state, {
                elements: {
                    $set: action.data.elements
                },
                totalElements: {$set: action.data.totalElements},
                totalPages: {$set: action.data.totalPages}
            })
        );

    }

    return (
            DealerRecommendationList.update(state, {
                elements: {
                    $push: action.data.elements
                },
                totalElements: {$set: action.data.totalElements},
                totalPages: {$set: action.data.totalPages}
            })
    );

};

const updateRecommendationComment = (state, action) => {

    const updatedRecommendation = [...state];

    const index = state.elements.findIndex(recommendation =>
        recommendation.id === action.data.id
    );

    if (index === -1) {

        return state;

    }

    updatedRecommendation.splice(index, 1, action.data);

    return DealerRecommendationList.update(state, {
        elements: {
            $push: action.data
        }
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.GET_DEALER_RECOMMENDATIONS]: updateDealerRecommendations,
        [actions.UPDATE_RECOMMENDATION_COMMENT_SUCCESS]: updateRecommendationComment
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/reducers/dealer-recommendation.js